import React from 'react'
import Button from '@mui/material/Button'
import { ButtonBaseProps } from '@mui/material'

export enum ButtonVariant {
  CONTAINED = 'contained',
  OUTLINED = 'outlined',
  TEXT = 'text',
}

const defaultSX = {
  btn: {
    borderRadius: 0,
    padding: '16px',
    fontWeight: '700',
    lineHeight: '22px',
    fontSize: '16px',
    textTransform: 'none',
    width: '100%',
  },
}

export interface BaseButtonProps extends ButtonBaseProps {
  className?: string
  disabled?: boolean
  sx?: object
  variant: ButtonVariant
}

/**
 * @param {BaseButtonProps} props
 * @param {string} props.className (Optional) - to customize the button if needed.
 * @param {boolean} props.disabled (Optional) - specifies either the BaseButton should be disabled or not.
 * @param {object} props.sx (Optional) - To customize the look and feel if needed.
 */

const BaseButton = (props: BaseButtonProps) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    props.onClick && props.onClick(event)
  }

  return (
    <Button
      className={props.className}
      disabled={props.disabled}
      disableElevation
      onClick={handleClick}
      sx={{ ...defaultSX.btn, ...props.sx }}
      variant={props.variant}
    >
      {props.children}
    </Button>
  )
}

BaseButton.defaultProps = {
  children: 'Continue',
  disabled: false,
  onClick: () => null,
  variant: ButtonVariant.CONTAINED,
}

export default BaseButton
